// React Query keys for the Mart pick list (under ['shop', id] so shop-wide invalidation reaches them).
export const martKeys = {
  pickList: (shopId: string) => ['shop', shopId, 'mart', 'pick'] as const,
  substitutes: (shopId: string, orderItemId: string, missing: number) => ['shop', shopId, 'mart', 'subs', orderItemId, missing] as const,
};
